// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import users from '@src/views/pages/user/store/reducer'
import dropcards from '@src/store/reducer/DropcardReducer'
import imports from '@src/views/pages/imports/store/reducer'
import booking from '@src/views/pages/summit-register copy 4/store/reducer'
import userBooking from '@src/views/pages/user-booking/store/reducer'
import bookingnew from '@src/views/pages/summit-register copy 4/store/reducer'
import booking3 from '@src/views/pages/user-payments/store/reducer'
import bookingnew3 from '@src/views/pages/summit-register copy 4/store/reducer'
import invites from '@src/views/pages/invites/store/reducer'
import authorizenet from '@src/views/pages/summit-register copy 4/store-authorizenet/reducer'
import password from '@src/views/pages/authentication/store/reducer'
import exhibitor from '@src/views/pages/exhibitors/store/reducer'
import registration from '@src/views/pages/registration/store/reducer'
import speakerpanelist from '@src/views/pages/speakerpanelist/store/reducer'
import abandoned from '@src/views/pages/abondend-user-payments/store/reducer'
import trash from '@src/views/pages/trash/store/reducer'
import booths from '@src/views/pages/booth-crud/store/reducer'
import aboutus from '@src/views/pages/aboutUs/store/reducer'
import appSetting from '@src/views/pages/appSetting/store/reducer'
import event from '@src/store/reducer/EventReducer'
import emailtemplate from '@src/views/pages/email-template/store/reducer'
import eventSettings from '@src/views/pages/event-settings/store/reducer/index.js'
import posts from '@src/views/pages/posts/store/reducer'
import advertisement from '@src/views/pages/advertisement/store/reducer'
import survey from '@src/views/pages/survey/store/reducer'
import pushs from '@src/views/push/store/reducer'
import conferenceevent from "@src/views/pages/conference-event/store/reducer"
import eventlist from "@src/views/event-list/store/reducer"
import agendalist from "@src/views/agenda-latest/store/reducer"
import categories from "@src/views/categories/store/reducer"
import dashboard from "@src/views/pages/dashboard/store/reducer/index.js"
import dashboard3 from "@src/views/pages/dashboard3/store/reducer/index.js"
import cancelledUsers from "@src/views/pages/cancelled-users/store/reducer/index.js"
import exhibitorLog from "@src/views/pages/exhibitor-logs/store/reducer/index.js"
import registrationRecords from "@src/views/pages/reports/store/reducer/index.js"
import notifications from "@src/store/reducer/NotificationReducer.js"
import floor from "@src/views/pages/floor/store/reducer/index.js"
import onDemandAds from "@src/views/pages/on-demand/on-demand-ads/store/reducer/index.js"

const rootReducer = combineReducers({
  auth,
  users,
  navbar,
  layout,
  notifications,
  dropcards,
  imports,
  booking,
  userBooking,
  bookingnew,
  booking3,
  bookingnew3,
  invites,
  authorizenet,
  password,
  exhibitor,
  registration,
  speakerpanelist,
  abandoned,
  trash,
  booths,
  aboutus,
  appSetting,
  event,
  emailtemplate,
  eventSettings,
  posts,
  advertisement,
  pushs,
  survey,
  conferenceevent,
  eventlist,
  agendalist,
  categories,
  dashboard,
  dashboard3,
  cancelledUsers,
  exhibitorLog,
  registrationRecords,
  floor,
  onDemandAds
})

export default rootReducer


